/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPBANKVERIFICATIONSTATUS = {
    Unverified: 'N',
    InProgress: 'X',
    Verified: 'Y'
} as const;
export type IAPBANKVERIFICATIONSTATUS = typeof IAPBANKVERIFICATIONSTATUS[keyof typeof IAPBANKVERIFICATIONSTATUS];


export function IAPBANKVERIFICATIONSTATUSFromJSON(json: any): IAPBANKVERIFICATIONSTATUS {
    return IAPBANKVERIFICATIONSTATUSFromJSONTyped(json, false);
}

export function IAPBANKVERIFICATIONSTATUSFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPBANKVERIFICATIONSTATUS {
    return json as IAPBANKVERIFICATIONSTATUS;
}

export function IAPBANKVERIFICATIONSTATUSToJSON(value?: IAPBANKVERIFICATIONSTATUS | null): any {
    return value as any;
}

